import { render } from "./Instruction.vue?vue&type=template&id=7f5d7287"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"

import "./Instruction.vue?vue&type=style&index=0&id=7f5d7287&lang=css"
script.render = render

export default script